"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargesToJSON = exports.ChargesFromJSONTyped = exports.ChargesFromJSON = exports.instanceOfCharges = exports.attributeTypeMapCharges = void 0;
exports.attributeTypeMapCharges = [
    {
        name: "needsCharge",
        type: "boolean",
    },
    {
        name: "chargeType",
        type: "string",
    },
    {
        name: "totalPriceInCents",
        type: "number",
    },
    {
        name: "freeFaxPagesLeft",
        type: "number",
    },
    {
        name: "faxPageCurrentCount",
        type: "number",
    },
    {
        name: "overageFaxMaxLimitInCents",
        type: "number",
    },
    {
        name: "pricePerFaxInCents",
        type: "number",
    },
    {
        name: "initialPageLimit",
        type: "number",
    },
    {
        name: "overagePriceInCentsPerPage",
        type: "number",
    },
    {
        name: "internationalMultiplier",
        type: "number",
    },
];
/**
 * Check if a given object implements the Charges interface.
 */
function instanceOfCharges(value) {
    if (!("needsCharge" in value) || value["needsCharge"] === undefined)
        return false;
    if (!("chargeType" in value) || value["chargeType"] === undefined)
        return false;
    if (!("totalPriceInCents" in value) ||
        value["totalPriceInCents"] === undefined)
        return false;
    if (!("freeFaxPagesLeft" in value) || value["freeFaxPagesLeft"] === undefined)
        return false;
    if (!("faxPageCurrentCount" in value) ||
        value["faxPageCurrentCount"] === undefined)
        return false;
    if (!("overageFaxMaxLimitInCents" in value) ||
        value["overageFaxMaxLimitInCents"] === undefined)
        return false;
    if (!("pricePerFaxInCents" in value) ||
        value["pricePerFaxInCents"] === undefined)
        return false;
    if (!("initialPageLimit" in value) || value["initialPageLimit"] === undefined)
        return false;
    if (!("overagePriceInCentsPerPage" in value) ||
        value["overagePriceInCentsPerPage"] === undefined)
        return false;
    if (!("internationalMultiplier" in value) ||
        value["internationalMultiplier"] === undefined)
        return false;
    return true;
}
exports.instanceOfCharges = instanceOfCharges;
function ChargesFromJSON(json) {
    return ChargesFromJSONTyped(json, false);
}
exports.ChargesFromJSON = ChargesFromJSON;
function ChargesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        needsCharge: json["needs_charge"],
        chargeType: json["charge_type"],
        totalPriceInCents: json["total_price_in_cents"],
        freeFaxPagesLeft: json["free_fax_pages_left"],
        faxPageCurrentCount: json["fax_page_current_count"],
        overageFaxMaxLimitInCents: json["overage_fax_max_limit_in_cents"],
        pricePerFaxInCents: json["price_per_fax_in_cents"],
        initialPageLimit: json["initial_page_limit"],
        overagePriceInCentsPerPage: json["overage_price_in_cents_per_page"],
        internationalMultiplier: json["international_multiplier"],
    };
}
exports.ChargesFromJSONTyped = ChargesFromJSONTyped;
function ChargesToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        needs_charge: value["needsCharge"],
        charge_type: value["chargeType"],
        total_price_in_cents: value["totalPriceInCents"],
        free_fax_pages_left: value["freeFaxPagesLeft"],
        fax_page_current_count: value["faxPageCurrentCount"],
        overage_fax_max_limit_in_cents: value["overageFaxMaxLimitInCents"],
        price_per_fax_in_cents: value["pricePerFaxInCents"],
        initial_page_limit: value["initialPageLimit"],
        overage_price_in_cents_per_page: value["overagePriceInCentsPerPage"],
        international_multiplier: value["internationalMultiplier"],
    };
}
exports.ChargesToJSON = ChargesToJSON;
